import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ToggleService } from '../../service/toggle.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public open: boolean = false;
  
  constructor(private toggleService : ToggleService) { }

  switchToggle(){
    this.toggleService.sidebar();
  }

  openTopbar(){
    this.open = !this.open;
  }

  ngOnInit() {
  }

}
